export default "__VITE_PUBLIC_ASSET__30d127b8__"